import { MapContainer, TileLayer } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-cluster';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import { ClienteMarker } from './ClienteMarker';
import { UserLocationMarker } from './UserLocationMarker';
import { RotaPolyline } from './RotaPolyline';
import type { ClienteMapa } from '../types/visita.types';
import type { GeoPosition } from '../services/geolocation.service';

// AIDEV-NOTE: Fix obrigatorio — Leaflet + Vite nao resolve os icones default corretamente
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import iconShadowUrl from 'leaflet/dist/images/marker-shadow.png';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({ iconUrl, shadowUrl: iconShadowUrl });

// AIDEV-NOTE: Centro default no Brasil (Brasilia) com zoom mostrando o pais inteiro
const BRASIL_CENTER: [number, number] = [-15.7801, -47.9292];
const DEFAULT_ZOOM = 4;

interface Props {
  clientes: ClienteMapa[];
  userPosition?: GeoPosition;
  rota?: {
    latLngs: [number, number][];
    distance?: string;
    duration?: string;
  };
  onCheckin?: (cliente: ClienteMapa) => void;
  onVerHistorico?: (cliente: ClienteMapa) => void;
}

export function MapaVisitas({ clientes, userPosition, rota, onCheckin, onVerHistorico }: Props) {
  return (
    <MapContainer
      center={BRASIL_CENTER}
      zoom={DEFAULT_ZOOM}
      style={{ height: '100%', width: '100%' }}
      scrollWheelZoom
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      {/* Cluster de marcadores de clientes */}
      <MarkerClusterGroup chunkedLoading>
        {clientes
          .filter((c) => c.lat != null && c.lng != null)
          .map((cliente) => (
            <ClienteMarker
              key={cliente.id}
              cliente={cliente}
              onCheckin={onCheckin ? () => onCheckin(cliente) : undefined}
              onVerHistorico={onVerHistorico ? () => onVerHistorico(cliente) : undefined}
            />
          ))}
      </MarkerClusterGroup>

      {/* Posicao do usuario */}
      {userPosition && (
        <UserLocationMarker
          lat={userPosition.lat}
          lng={userPosition.lng}
          accuracy={userPosition.accuracy}
        />
      )}

      {/* Rota OSRM */}
      {rota && rota.latLngs.length >= 2 && (
        <RotaPolyline latLngs={rota.latLngs} distance={rota.distance} duration={rota.duration} />
      )}
    </MapContainer>
  );
}
